import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { BiLoaderAlt } from 'react-icons/bi';
import { useTranslation } from 'react-i18next';
import api from '../../utils/api';
import { ISMResponse } from '../../models';
import { MdDone, MdErrorOutline } from 'react-icons/md';

export default function Index() {
    const [searchParams] = useSearchParams();
    const { t } = useTranslation();
    const [activationStatus, setActivationStatus] = useState<
        'activating' | 'activated' | 'activationTokenInvalid'
    >('activating');

    async function activateAccount() {
        if (!searchParams.has('token')) {
            return setActivationStatus('activationTokenInvalid');
        }
        const response = await api.get(`auth/activate?token=${searchParams.get('token')}`);
        const responseJSON = (await response.json()) as ISMResponse<{
            message: 'account activated';
        }>;
        if (responseJSON.status === 'success') {
            return setActivationStatus('activated');
        } else {
            return setActivationStatus('activationTokenInvalid');
        }
    }

    useEffect(() => {
        activateAccount();
    });

    return (
        <div className={'flex min-h-[calc(100vh-72px)] flex-col items-center justify-center gap-2'}>
            {activationStatus === 'activating' && (
                <>
                    <div className={'animate-spin-slow'}>
                        <BiLoaderAlt className={'text-6xl text-SM-yellow'} />
                    </div>
                    <h2 className={'text-center'}>
                        {t('translation:ACTIVATE.ACTIVATING_ACCOUNT')}
                    </h2>
                </>
            )}

            {activationStatus === 'activationTokenInvalid' && (
                <>
                    <div>
                        <MdErrorOutline className={'text-6xl text-red-600'} />
                    </div>
                    <h2 className={'text-center'}>
                        {t('translation:ACTIVATE.ACCOUNT_CANNOT_BE_ACTIVATED')}
                    </h2>
                    <Link to={'/'}>
                        <button className={'btn-filled bg-red-600 text-white ring-red-600/50'}>
                            {t('translation:ACTIVATE.RETURN_TO_MAIN_PAGE')}
                        </button>
                    </Link>
                </>
            )}

            {activationStatus === 'activated' && (
                <>
                    <div>
                        <MdDone className={'text-6xl text-green-600'} />
                    </div>
                    <h2 className={'text-center'}>{t('translation:ACTIVATE.ACCOUNT_ACTIVATED')}</h2>
                    <Link to={'/'}>
                        <button className={'btn-filled bg-green-600 text-white ring-green-600/50'}>
                            {t('translation:ACTIVATE.RETURN_TO_MAIN_PAGE')}
                        </button>
                    </Link>
                </>
            )}
        </div>
    );
}
